export default __webpack_public_path__ + "static/media/term-condition-vn.c79bb188.svg";